if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  /*
  * Agência Mofo Design
  * localStorage é isolado por subdomínio (origin); como a troca de unidade
  * redireciona para outro subdomínio, precisamos de um cookie com domain
  * compartilhado (.eliaspa.com.br) pra essa escolha sobreviver ao redirect.
  * O popup.js lê esse mesmo cookie como fallback do localizationForm.
  */
  window.EurusSetLocalizationCookie = function (rawValue) {
    const expires = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `localizationForm=${encodeURIComponent(rawValue)}; expires=${expires}; path=/; domain=.eliaspa.com.br; SameSite=Lax`;
  };

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        loading: false,
        cachedResults: false,
        async submit(value, input, name) {
          /*
          * Agência Mofo Design
          * Implementada limpeza do carrinho quando trocada a localidade
          */
          const fn_submit = () =>  {
            this.$el.closest("#localization_form").querySelector('#'+input).value = value;
            this.$el.closest("#localization_form").submit();
          }

          const storedRaw = localStorage.getItem('localizationForm');
          const stored = xParseJSON(storedRaw);
          const storedValue = stored && typeof stored === 'object' ? stored.value : stored;

          if(value !== storedValue) {
            const cart = await this.getCart();
            if (cart && cart?.items?.length > 0) {
              await this.cleanCart(value, name, fn_submit);
              return;
            }
          }

          const payload = JSON.stringify({ value, name, expires: Date.now() + 14 * 24 * 60 * 60 * 1000 });
          localStorage.setItem('localizationForm', payload);
          window.EurusSetLocalizationCookie(payload);
          fn_submit();
        },
        async getCart() {
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');

            if (!response.ok) {
              throw new Error(`Erro ao buscar carrinho: ${response.status}`);
            }

            const cart = await response.json();
            return cart;
          } catch (e) {
            console.error('getCart error:', e);
            return null;
          }
        },
        async cleanCart(cacheValue, cacheName, cb) {
          Swal.fire({
            title: 'Atenção!',
            html: `
              Não é possível adicionar ao carrinho, produtos de unidades diferentes.<br> Ao mudar de unidade o seu carrinho será limpo e você precisará selecionar novos produtos.
            `,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Mudar para Unidade Selecionada',
            cancelButtonText: 'Continuar na Unidade Atual',
            reverseButtons: true,
            customClass: {
              confirmButton: 'button button-action',
              cancelButton: 'button button-outline'
            }
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              // limpar carrinho / trocar unidade
              if (cacheValue) {
                const payload = JSON.stringify({ value: cacheValue, name: cacheName, expires: Date.now() + 14 * 24 * 60 * 60 * 1000 });
                localStorage.setItem('localizationForm', payload);
                window.EurusSetLocalizationCookie(payload);
              }

              await fetch(window.Shopify.routes.root + 'cart/clear.js')
                .catch(e => console.error('Failed in cleaning the cart: ', e));
              cb();
            }
          });
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }))
    });
  });
}